<template>
    <vue-draggable-resizable class="ql-position-cue-marker" :key="handler"
        :style="{color: cueColor(cue), transform: transformStyle(), '--cue-bgColor': cueColor(cue)}"
        :handles="[]"
        :x="cuePosLeft" :y="cuePosTop"
        :w="cuePosWidth" :h="cuePosHeight"
        :minw="2" :minh="2"
        :parent="true"
        :draggable="editable && !locked"
        @dragging="onDrag"
        @dragstop="onDragStop"
        @activated="onActivate"
        @deactivated="onDeactivate"
    >
    </vue-draggable-resizable>
</template>

<script>
// 

import { mapGetters } from 'vuex';
import vueDragResize from 'vue-draggable-resizable';
/**
 * Component For...
 */
const CuePositionMarker = {
    name: 'CuePositionMarker',
    props: ['cue', 'locked', 'editable', 'pageWidth', 'pageHeight'],
    data: function() {
        return {
            dragging: false,
            handler: 0,
            selectedScale: localStorage.getItem('page-print-scale') || 1
        };
    },
    watch: {
        'cue.x': function() {
            if (!this.dragging) {
                this.handler++;
            }
        },
        'cue.y': function() {
            if (!this.dragging) {
                this.handler++;
            }
        },
        'cue.width': function() {
            this.handler++;
        },
        'cue.height': function() {
            this.handler++;
        }
    },
    computed: {
        ...mapGetters([
            'layerByCue'
        ]),
        layer: function() {
            return this.layerByCue(this.cue);
        },
        cuePosLeft() {
            if (!this.dragging && this.cue.x <= 1) {
                return this.cue.x * this.pageWidth;
            }
            return this.cue.x;
        },
        cuePosTop() {
            if (!this.dragging && this.cue.y <= 1) {
                return this.cue.y * this.pageHeight;
            }
            return this.cue.y;
        },
        cuePosWidth() {
            return (this.cue.width || 4) * this.selectedScale;
        },
        cuePosHeight() {
            return (this.cue.height || 4) * this.selectedScale;
        }
    },
    methods: {
        cueColor(cue) {
            const layer = this.layerByCue(cue);
            if (layer) return layer.color;

            return 'black';
        },
        transformStyle() {
            const transformValue = `translate(${this.cuePosLeft}px, ${this.cuePosTop + 1}px)`;
            return transformValue;
        },
        onDrag(x, y) {
            this.cue.x = x;
            this.cue.y = y;
            this.dragging = true;
        },
        onDragStop(x, y) {
            const cue = {
                ...this.cue,
                x: x,
                y: y
            };
            this.dragging = false;
            this.$emit('updateCue', cue);
            this.onDeactivate();
        },
        onActivate() {
            this.$emit('activated');
        },
        onDeactivate() {
            this.$emit('deactivated');
        }
    },
    components: {
        'vue-draggable-resizable': vueDragResize
    },

    mounted: function() {
    }
};

export default CuePositionMarker;
</script>

<style lang="scss">
.ql-position-cue-marker::before {
    content: '';
    position: absolute;
    top: 0;
    font-weight: bold;
    font-size: var(--cue-marker-font-size, 21px);
    width: 4%;
    height: 50%;
    background-color: var(--cue-bgColor);
    left: var(--cue-left);
}

.ql-position-cue-marker {
    width: 5px;
    height: 5px;
    opacity: 1;
    cursor: move;
    color: black;
    pointer-events: fill;
    border-radius: 15px;
}

.ql-marker-icon {
    text-rendering: optimizeLegibility;
    vertical-align: middle;
}

.ql-selection-cue-marker .resizeable {
    pointer-events: stroke;
    cursor: nwse-resize;
}

.ql-selection-cue-marker .moveable {
    pointer-events: fill;
    cursor: move;
}
</style>


// WEBPACK FOOTER //
// cue-position-marker.vue?0e77ce04